import PropTypes from 'prop-types';
import { m } from 'framer-motion';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// ----------------------------------------------------------------------

const varPath = {
  animate: {
    fillOpacity: [0, 0, 1, 0, 0],
    pathLength: [0, 0.4, 1, 0.4, 0],
    transition: {
      duration: 4,
      ease: [0.43, 0.13, 0.23, 0.96],
      repeat: Infinity,
      repeatDelay: 1,
    },
  },
};

// ----------------------------------------------------------------------

LoadingLogo.propTypes = {
  sx: PropTypes.object,
};

export default function LoadingLogo({ ...sx }) {
  const theme = useTheme();
  const PRIMARY_MAIN = theme.palette.primary.main;
  const SECONDARY_MAIN = theme.palette.secondary.main;
  return (
    <Box
      component={m.svg}
      viewBox="0 0 69.12 51.06"
      sx={{
        width: 120,
        height: 120,
        strokeWidth: 1,
        ...sx,
      }}
    >
      <g fill="none" fillRule="nonzero" id="sowan_ar_icon" data-name="Sowan Ar Icon">
        <m.path
          {...varPath}
          d="M26.69,18.58l2.81-6,7.7-1.44a7.71,7.71,0,0,1-1-3.82A7.55,7.55,0,0,1,38.1,2.12,6,6,0,0,1,42.75,0,6.11,6.11,0,0,1,47.5,2.09a7.55,7.55,0,0,1,1.87,5.25,8.62,8.62,0,0,1-1.84,5.51,7.1,7.1,0,0,1-4.71,2.77ZM43,9.29a2.93,2.93,0,0,0,1.37-2.38c0-1.29-.48-1.94-1.44-1.94s-1.51.65-1.51,1.94A2.76,2.76,0,0,0,43,9.29Z"
          fill={PRIMARY_MAIN}
          stroke={PRIMARY_MAIN}
        />
        <m.path
          {...varPath}
          d="M24.26,42.28A42.08,42.08,0,0,1,34.34,25.21q7.35-7.34,16.85-7.34,8.51,0,13.61,5.9a18.12,18.12,0,0,1,4.32,12.32v1.58q0,6.55-4.1,10.22a13.15,13.15,0,0,1-9.15,3.17H24.77a13.3,13.3,0,0,1-8.71-2.81,13.35,13.35,0,0,1-8.72,2.81H0V42.35H6.48a5.29,5.29,0,0,0,3.89-1.19,5.61,5.61,0,0,0,1.15-4V23.66l9.07-.75V37.17C20.59,40.24,21.82,41.94,24.26,42.28Zm35.79-5.19v-1A10.2,10.2,0,0,0,57.6,29a8.12,8.12,0,0,0-6.34-2.74,15.5,15.5,0,0,0-10.47,4.32,29.18,29.18,0,0,0-7.67,11.74H55.51c1.73,0,2.92-.37,3.57-1.12S60.05,39.11,60.05,37.09Z"
          fill={SECONDARY_MAIN}
          stroke={SECONDARY_MAIN}
        />
      </g>
    </Box>
  );
}
